import { AppState } from '~system/store/configure-store';

export const selectIsTenantAuthenticated = (state: AppState) =>
  !!state.tenantAuth.accessToken;

export const selectTenantAuth = (state: AppState) => state.tenantAuth;
